import { useEffect, useRef } from 'react';

// mobile-ui.6.F F4 — prompt de escopo do alinhamento em massa.
// "Só esta" é a ação default/primeira (decisão do PO, risco R3): Escape e
// clique fora também aplicam "Só esta" — quem ignora o prompt mantém o
// comportamento atual (alinhar só o campo clicado) sem travar o fluxo.
export interface AlignmentScopePromptProps {
  /** Ação default — também disparada em Escape/clique fora. */
  onOnlyThis: () => void;
  onAll: () => void;
}

export function AlignmentScopePrompt({ onOnlyThis, onAll }: AlignmentScopePromptProps) {
  const ref = useRef<HTMLDivElement>(null);
  const onOnlyThisRef = useRef(onOnlyThis);
  onOnlyThisRef.current = onOnlyThis;

  useEffect(() => {
    const handlePointerDown = (e: PointerEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onOnlyThisRef.current();
      }
    };
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onOnlyThisRef.current();
    };
    document.addEventListener('pointerdown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('pointerdown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div
      ref={ref}
      role="group"
      aria-label="Aplicar a todas as perguntas?"
      className="mt-2 rounded-lg border border-neutral-700/50 bg-neutral-800/80 p-2"
      data-testid="alignment-scope-prompt"
    >
      <p className="mb-1.5 text-center text-xs text-neutral-300">
        Aplicar a todas as perguntas?
      </p>
      <div className="flex justify-center gap-1">
        <button
          type="button"
          autoFocus
          onClick={onOnlyThis}
          className="rounded-lg bg-white/10 px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/50"
        >
          Só esta
        </button>
        <button
          type="button"
          onClick={onAll}
          className="rounded-lg px-3 py-1.5 text-xs text-neutral-400 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/50"
        >
          Todas
        </button>
      </div>
    </div>
  );
}
